// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"412":"37151f82","500":"34897f31"}[chunkId] + ".chunk.css";
};